import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Card, EmptyState } from '../../ui';
import { ReactComponent as LockIcon } from '../../assets/icons/lock.svg';
import './AdminLayout.css';

/*
 * Estado bloqueado de una función solo de Business (white-label, política de
 * red, auditoría) cuando la org está en Team. El servidor responde 402
 * `plan_upgrade_required` a esas rutas; esto evita pintar formularios que
 * fallarían. Lleva a Billing solo si el rol puede gestionarlo.
 */
function PlanLocked({ orgId, canBilling }) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Card>
      <EmptyState
        icon={LockIcon}
        title={t('admin.planLocked.title')}
        description={canBilling ? t('admin.planLocked.description') : `${t('admin.planLocked.description')} ${t('admin.planLocked.askBilling')}`}
        actionLabel={canBilling ? t('admin.planLocked.cta') : undefined}
        onAction={canBilling ? () => navigate(`/admin/${orgId}/billing`) : undefined}
      />
    </Card>
  );
}

export default PlanLocked;
